export class ErrorMessages {
    public static readonly FILE_UPLOAD_ERROR = "Failed to upload a file. Please reach out to the team to resolve this";
    public static readonly FORBIDDEN_ERROR = "You don't have permissions to perform this action. Please reach out to the team to resolve this";
    public static readonly INTERNAL_SERVER_ERROR = "Internal server error occurred. Please try again or reach out to the team to resolve this";
}